/**
 * WWG Store admin settings mock data.
 *
 * The shape mirrors the Settings screen (single "Notifications" tab):
 *  - outOfStock / reorder: the contacts notified for each event
 *    ([{ name, department, email }])
 *  - outOfStockDefaultWeeks / reorderDefaultWeeks: the respective re-order threshold
 *  - outOfStockItemSpecific / reorderItemSpecific: respective per-SKU overrides
 *
 * This is intentionally mutable module state so per-section saves persist
 * across in-app navigation during a session (they do NOT survive a page
 * refresh — that needs the real backend, consistent with the other mocks).
 */

export const settings = {
  outOfStock: [
    {
      name: "Justin Purcell",
      department: "Publications",
      email: "jrp@wwdb.com",
    },
  ],
  outOfStockDefaultWeeks: 1,
  outOfStockItemSpecific: [],
  reorder: [
    {
      name: "Justin Purcell",
      department: "Publications",
      email: "jrp@wwdb.com",
    },
  ],
  reorderDefaultWeeks: 2,
  reorderItemSpecific: [{ sku: "BK187", weeksRemaining: 5 }],
};

const settingsMock = { settings };
export default settingsMock;
